import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import AuthLayout from '@/components/AuthLayout';
import { authApi } from '@/features/auth/auth.api';

export default function ForgotPasswordPage(): JSX.Element {
  const [sent, setSent] = useState(false);
  const { register, handleSubmit, formState } = useForm<{ email: string }>();

  const onSubmit = handleSubmit(async ({ email }) => {
    await authApi.forgotPassword(email).catch(() => undefined);
    setSent(true);
    toast.success('If that email exists, a reset link is on its way.');
  });

  return (
    <AuthLayout title="Reset your password" subtitle="We’ll email you a reset link">
      {sent ? (
        <p className="text-sm text-slate-600 dark:text-slate-400">
          Check your inbox for the reset link. Didn’t get it? Check spam or try again.
        </p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium">Email</label>
            <input className="input" type="email" {...register('email', { required: true })} />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={formState.isSubmitting}>
            {formState.isSubmitting ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
      <p className="mt-6 text-center text-sm">
        <Link to="/login" className="text-brand-600 hover:underline">
          Back to login
        </Link>
      </p>
    </AuthLayout>
  );
}
